import * as types from './mutation-types'
import { getAssets, uploadAsset, updateAsset, importAsset, createSchema, getImportableAssets } from '@/services/Assets'

export const clear = ({ commit }) => {
  commit(types.CLEAR)
}

export const fetchAssets = ({ commit }, data) => {
  return getAssets(data)
}

export const fetchPromotableAssets = ({ commit }, data) => {
  return getImportableAssets(data)
}

export const importStagedAssets = ({ commit }, assets) => {
  return importAsset(assets.map(asset => asset.id))
}

export const uploadFile = ({ commit }, data) => {
  return uploadAsset(data)
}

export const updateFile = ({ commit }, data) => {
  return updateAsset(data)
}

export const uploadSchema = ({ commit }) => {
  return createSchema()
}

export default {
  fetchAssets,
  fetchPromotableAssets,
  importStagedAssets,
  uploadFile,
  updateFile,
  uploadSchema
}
